module.exports = __webpack_public_path__ + "static/media/cw_article_list.7987ba21.png";